var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 93,
    viewBox: "0 0 106 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9997 66.3335H39.333V90.3335H65.9997V66.3335Z",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98 2.3335H7.33333C4.38781 2.3335 2 4.72131 2 7.66683V61.0002C2 63.9457 4.38781 66.3335 7.33333 66.3335H98C100.946 66.3335 103.333 63.9457 103.333 61.0002V7.66683C103.333 4.72131 100.946 2.3335 98 2.3335Z",
    stroke: "white",
    strokeWidth: 3.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.333 53H57.9997",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90.3335H79.3333",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteImg);
export default __webpack_public_path__ + "static/media/WebsiteImg.994f68254f9674d28ed489ad9a0c1d8e.svg";
export { ForwardRef as ReactComponent };